import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import logo from '../../assets/images/logo-ipnet.png';

const Forbidden = (): JSX.Element => {
  const { t: translate } = useTranslation();
  const history = useHistory();
  return (
    <main className="page-not-found">
      <section className="page-section">
        <img src={logo} className="logo" alt="IPNET" />
        <h1>{translate('forbidden_text')}</h1>
        <button className={'btn btn-primary'} onClick={history.goBack}>
          {translate('go_back')}
        </button>
        <footer className="page-footer">
          <a className="App-link" href="https://www.ipnet.cloud/" target="_blank" rel="noopener noreferrer">
            IPNET - Growth Partner
          </a>
        </footer>
      </section>
    </main>
  );
};

export default Forbidden;
